// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/core/svc_access.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { AcceptSharingReq, AcceptSharingResp, CancelSharingInvitationReq, CancelSharingInvitationResp, GetInvitationByTokenReq, GetInvitationByTokenResp, InviteStaffReq, InviteStaffResp, RemoveOrganizationStaffReq, RemoveOrganizationStaffResp, RevokeSharingReq, RevokeSharingResp, SetOrganizationStaffRoleReq, SetOrganizationStaffRoleResp, SetPatientTeamMembersReq, SetPatientTeamMembersResp, SharedByMeStreamReq, SharedWithMeStreamReq, SharePatientReq, SharePatientResp, SharingListStreamResp } from "./svc_access_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.core.AccessService
 */
export const AccessService = {
  typeName: "com.diagnocat.core.AccessService",
  methods: {
    /**
     * Shared by me or shared by staff (if Me has admin organization role)
     *
     * @generated from rpc com.diagnocat.core.AccessService.SharedByMeStream
     */
    sharedByMeStream: {
      name: "SharedByMeStream",
      I: SharedByMeStreamReq,
      O: SharingListStreamResp,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc com.diagnocat.core.AccessService.SharedWithMeStream
     */
    sharedWithMeStream: {
      name: "SharedWithMeStream",
      I: SharedWithMeStreamReq,
      O: SharingListStreamResp,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Only for Recipient (Recipient.UserID == meID)
     *
     * @generated from rpc com.diagnocat.core.AccessService.GetInvitationByToken
     */
    getInvitationByToken: {
      name: "GetInvitationByToken",
      I: GetInvitationByTokenReq,
      O: GetInvitationByTokenResp,
      kind: MethodKind.Unary,
    },
    /**
     * Share a patient with a user who is not an employee of this patient's organization.
     *
     * Permission: PatientPermissions.CanShare
     *
     * @generated from rpc com.diagnocat.core.AccessService.SharePatient
     */
    sharePatient: {
      name: "SharePatient",
      I: SharePatientReq,
      O: SharePatientResp,
      kind: MethodKind.Unary,
    },
    /**
     * Invite a user to join the organization as a staff member.
     * If the recipient is already a staff member, OrganizationStaff is returned immediately without sending an email.
     *
     * Permission: OrganizationPermissions.CanEditStaff
     *
     * @generated from rpc com.diagnocat.core.AccessService.InviteStaff
     */
    inviteStaff: {
      name: "InviteStaff",
      I: InviteStaffReq,
      O: InviteStaffResp,
      kind: MethodKind.Unary,
    },
    /**
     * Accept sharing
     *
     * @generated from rpc com.diagnocat.core.AccessService.AcceptSharing
     */
    acceptSharing: {
      name: "AcceptSharing",
      I: AcceptSharingReq,
      O: AcceptSharingResp,
      kind: MethodKind.Unary,
    },
    /**
     * Cancel not accepted invitation (`InvitationStatus` == `StatusPending`)
     *
     * Permission:
     * - Me.ID == `invitation.Created.By`
     * - `PatientPermissions.CanCancelOthersSharings`
     *
     * @generated from rpc com.diagnocat.core.AccessService.CancelSharingInvitation
     */
    cancelSharingInvitation: {
      name: "CancelSharingInvitation",
      I: CancelSharingInvitationReq,
      O: CancelSharingInvitationResp,
      kind: MethodKind.Unary,
    },
    /**
     * Revoke sharing
     *
     * Permission: PatientPermissions.CanCancelOthersSharings || Sharing.Created.By == meID
     *
     * @generated from rpc com.diagnocat.core.AccessService.RevokeSharing
     */
    revokeSharing: {
      name: "RevokeSharing",
      I: RevokeSharingReq,
      O: RevokeSharingResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set patient doctors(Users).
     * If the user removes a staff member from the list of patient’s doctors
     * all tasks that were assigned to this person will also be unassigned from this person.
     *
     * Permission: PatientPermissions.CanEditTeam
     *
     * @generated from rpc com.diagnocat.core.AccessService.SetPatientTeamMembers
     */
    setPatientTeamMembers: {
      name: "SetPatientTeamMembers",
      I: SetPatientTeamMembersReq,
      O: SetPatientTeamMembersResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set staff member role
     *
     * Permission: OrganizationPermissions.CanEditStaff
     *
     * @generated from rpc com.diagnocat.core.AccessService.SetOrganizationStaffRole
     */
    setOrganizationStaffRole: {
      name: "SetOrganizationStaffRole",
      I: SetOrganizationStaffRoleReq,
      O: SetOrganizationStaffRoleResp,
      kind: MethodKind.Unary,
    },
    /**
     * Remove staff member from organization -> the staff member loses access to the organization
     *
     * Permission: OrganizationPermissions.CanEditStaff
     *
     * Errors:
     * - type: BadRequestError, Reason: Owner role cannot be deleted
     *
     * @generated from rpc com.diagnocat.core.AccessService.RemoveOrganizationStaff
     */
    removeOrganizationStaff: {
      name: "RemoveOrganizationStaff",
      I: RemoveOrganizationStaffReq,
      O: RemoveOrganizationStaffResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

